// Libraries
import React from 'react';

// Supermove
import {Styled} from '@supermove/components';
import {colors} from '@supermove/styles';

// Shared
import Text from '@shared/design/components/Text';

const Container = Styled.View<{
  size: number;
  borderSize: number;
  borderColor: string;
  color: string;
}>`
  align-items: center;
  justify-content: center;
  height: ${({size}) => size}px;
  width: ${({size}) => size}px;
  border-width: ${({borderSize}) => borderSize}px;
  border-color: ${({borderColor}) => borderColor};
  border-radius: ${({size}) => size / 2}px;
  background-color: ${({color}) => color};
`;

type AvatarType = {
  borderColor?: string;
  borderSize?: number;
  color?: string;
  size: number;
  text?: string;
  textColor?: string;
};

const Avatar = ({
  borderColor = colors.blue.interactive,
  borderSize = 0,
  color = colors.blue.interactive,
  size,
  text = '',
  textColor = colors.white,
}: AvatarType) => (
  <Container borderColor={borderColor} borderSize={borderSize} color={color} size={size}>
    <Text.Heading2 style={{color: textColor}}>{text}</Text.Heading2>
  </Container>
);

export default Avatar;
